export const PlayIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.02439 21.7459C5.39188 21.3925 5 20.7246 5 20V4C5 3.27544 5.39188 2.60754 6.02439 2.25409C6.65691 1.90065 7.43111 1.91694 8.04819 2.29668L21.0482 10.2967C21.6397 10.6607 22 11.3055 22 12C22 12.6945 21.6397 13.3393 21.0482 13.7033L8.04819 21.7033C7.43111 22.0831 6.65691 22.0994 6.02439 21.7459ZM7 20L20 12L7 4V20Z"
        fill="currentColor"
      />
    </svg>
  );
};
